/**
 * A function to create a log object for the 'manageBadgesClick' event (evid: 101)
 *
 * Event description: Click on manage badges button from different points of entry.
 *
 * @param {manageBadgesClickParams} params - The parameters for this event
 * @property {string} origin - Editor/BM
 * @property {string} formOrigin - challenges/forum
 * @return {LogObject<manageBadgesClickParams>} LogObject<manageBadgesClickParams>
 */
export function manageBadgesClick(params) {
    return { evid: 101, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'badgesLoaded' event (evid: 102)
 *
 * Event description: Event on Badges page successful load
 *
 * @param {badgesLoadedParams} params - The parameters for this event
 * @property {string} formOrigin - challenges/forum
 * @property {string} origin - place click came from
 * @return {LogObject<badgesLoadedParams>} LogObject<badgesLoadedParams>
 */
export function badgesLoaded(params) {
    return { evid: 102, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'newBadgeClick' event (evid: 103)
 *
 * Event description: Event on Create Badges click
 *
 * @param {newBadgeClickParams} params - The parameters for this event
 * @property {boolean} isCorvid - null for old ones, flag if it was triggered from corvid
 * @property {string} formOrigin - challenges/forum
 * @return {LogObject<newBadgeClickParams>} LogObject<newBadgeClickParams>
 */
export function newBadgeClick(params) {
    return { evid: 103, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'badgeTabOpened' event (evid: 104)
 *
 * Event description: Badge tab opened event (with indication of tab)
 *
 * @param {badgeTabOpenedParams} params - The parameters for this event
 * @property {string} tabName - Tab Name which was opened (settings, members, permissions)
 * @property {string} formOrigin - challenges/forum
 * @return {LogObject<badgeTabOpenedParams>} LogObject<badgeTabOpenedParams>
 */
export function badgeTabOpened(params) {
    return { evid: 104, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'badgeSaved' event (evid: 105)
 *
 * Event description: Badge save button click
 *
 * @param {badgeSavedParams} params - The parameters for this event
 * @property {string} badgeTextColor - badge text color
 * @property {string} badgeName - badge name
 * @property {string} imageCode - image code of chosen image or null if no selected
 * @property {GUID} badgeid - badge_id
 * @property {boolean} isCorvid - null for old ones, flag if it was triggered from corvid
 * @property {string} badgeBackgroundColor - badge background color
 * @property {string} badgeDescription - badge description
 * @property {string} formOrigin - challenges/forum
 * @return {LogObject<badgeSavedParams>} LogObject<badgeSavedParams>
 */
export function badgeSaved(params) {
    return { evid: 105, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'assignMembersClick' event (evid: 106)
 *
 * Event description: Click on assign members button
 *
 * @param {assignMembersClickParams} params - The parameters for this event
 * @property {GUID} assigneeMemberId - assigned member ID
 * @property {boolean} isCorvid - null for old ones, flag if it was triggered from corvid
 * @property {string} actionName - assign or remove
 * @property {GUID} badgeId - badge id
 * @property {string} formOrigin - challenges/forum
 * @return {LogObject<assignMembersClickParams>} LogObject<assignMembersClickParams>
 */
export function assignMembersClick(params) {
    return { evid: 106, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'permissionsToggle' event (evid: 107)
 *
 * Event description: Permission toggle changed status
 *
 * @param {permissionsToggleParams} params - The parameters for this event
 * @property {boolean} toggleStatus - True - On, False - Off
 * @property {GUID} badgeId - badge id
 * @return {LogObject<permissionsToggleParams>} LogObject<permissionsToggleParams>
 */
export function permissionsToggle(params) {
    return { evid: 107, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'managePermissionsClick' event (evid: 108)
 *
 * Event description: manage permissions click
 *
 * @param {managePermissionsClickParams} params - The parameters for this event
 * @return {LogObject<managePermissionsClickParams>} LogObject<managePermissionsClickParams>
 */
export function managePermissionsClick(params) {
    return { evid: 108, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'badgeEditClick' event (evid: 109)
 *
 * Event description: Badge Edit click
 *
 * @param {badgeEditClickParams} params - The parameters for this event
 * @property {GUID} badgeId - badge id
 * @property {string} formOrigin - challenges/forum
 * @return {LogObject<badgeEditClickParams>} LogObject<badgeEditClickParams>
 */
export function badgeEditClick(params) {
    return { evid: 109, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'badgeDeleteClick' event (evid: 110)
 *
 * Event description: Badge Delete click from pop up (confirmation pop-up click)
 *
 * @param {badgeDeleteClickParams} params - The parameters for this event
 * @property {boolean} isCorvid - null for old ones, flag if it was triggered from corvid
 * @property {GUID} badgeId - badge id
 * @property {string} action - delete;delete-confirm
 * @property {string} formOrigin - challenges/forum
 * @return {LogObject<badgeDeleteClickParams>} LogObject<badgeDeleteClickParams>
 */
export function badgeDeleteClick(params) {
    return { evid: 110, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'clickOnBadgesFromProfile' event (evid: 112)
 *
 * Event description: Click on badges from profile
 *
 * @param {clickOnBadgesFromProfileParams} params - The parameters for this event
 * @property {string} origin - origin of click (null represents - header click). Null/header/badges widget
 * @property {GUID} viewedMemberId - viewed site member id
 * @property {number} badgesCount - member badges count on event time
 * @return {LogObject<clickOnBadgesFromProfileParams>} LogObject<clickOnBadgesFromProfileParams>
 */
export function clickOnBadgesFromProfile(params) {
    return { evid: 112, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'badgeListPageLoaded' event (evid: 113)
 *
 * Event description: badge list page loaded
 *
 * @param {badgeListPageLoadedParams} params - The parameters for this event
 * @property {GUID} viewedMemberId - viewed site member id
 * @property {boolean} isCorvid - null for old ones, flag if it was triggered from corvid
 * @return {LogObject<badgeListPageLoadedParams>} LogObject<badgeListPageLoadedParams>
 */
export function badgeListPageLoaded(params) {
    return { evid: 113, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'badgeScreenLoaded' event (evid: 114)
 *
 * Event description: Badge screen loaded
 *
 * @param {badgeScreenLoadedParams} params - The parameters for this event
 * @property {string} origin - e.g. clicked from 'members profile', 'all badges page', etc
 * @property {GUID} badgeId - badge_id
 * @property {GUID} viewedMemberId - viewed site member id
 * @property {number} badgesCount - member badges count on event time
 * @return {LogObject<badgeScreenLoadedParams>} LogObject<badgeScreenLoadedParams>
 */
export function badgeScreenLoaded(params) {
    return { evid: 114, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'manageBadgesClickFromProfile' event (evid: 115)
 *
 * Event description: Click on Manage Badges From Profile
 *
 * @param {manageBadgesClickFromProfileParams} params - The parameters for this event
 * @property {GUID} viewedMemberId - Manage Badges Click from particular Member profile
 * @return {LogObject<manageBadgesClickFromProfileParams>} LogObject<manageBadgesClickFromProfileParams>
 */
export function manageBadgesClickFromProfile(params) {
    return { evid: 115, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'badgeCardClickAssign' event (evid: 116)
 *
 * Event description: badge card click assign event. Button usage checking
 *
 * @param {badgeCardClickAssignParams} params - The parameters for this event
 * @property {GUID} badgeid - badge on which this button was clicked
 * @property {string} origin - Toast/Badge card click
 * @return {LogObject<badgeCardClickAssignParams>} LogObject<badgeCardClickAssignParams>
 */
export function badgeCardClickAssign(params) {
    return { evid: 116, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'assignModalOpened' event (evid: 117)
 *
 * Event description: assign members modal opened
 *
 * @param {assignModalOpenedParams} params - The parameters for this event
 * @property {number} membersCount - number of members displayed in the modal
 * @property {string} formOrigin - challenges (history - nulls), automations
 * @return {LogObject<assignModalOpenedParams>} LogObject<assignModalOpenedParams>
 */
export function assignModalOpened(params) {
    return { evid: 117, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'badgesSelectModalOpened' event (evid: 118)
 *
 * Event description: sent when select modal opens when trying to connect badges to services
 *
 * @param {badgesSelectModalOpenedParams} params - The parameters for this event
 * @property {string} serviceId - challenges/forum category that badge is being connected to
 * @property {number} badgesCount - available badges count
 * @property {string} formOrigin - vertical which trigerred
 * @return {LogObject<badgesSelectModalOpenedParams>} LogObject<badgesSelectModalOpenedParams>
 */
export function badgesSelectModalOpened(params) {
    return { evid: 118, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'badgesConnectModalSaved' event (evid: 119)
 *
 * Event description: sent when selected badges from he modal were saved
 *
 * @param {badgesConnectModalSavedParams} params - The parameters for this event
 * @property {string} badgeIds - array of badgeID that were selected
 * @property {string} serviceId - challenges/forum category that badge is being connected to
 * @property {string} formOrigin - vertical that triggered form open {Challenges}
 * @return {LogObject<badgesConnectModalSavedParams>} LogObject<badgesConnectModalSavedParams>
 */
export function badgesConnectModalSaved(params) {
    return { evid: 119, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'badgesSetupModalLoaded' event (evid: 120)
 *
 * Event description: badges create/edit screen loaded (triggered by vertical, used because we do not have Create/Edit click events from verticals)
 *
 * @param {badgesSetupModalLoadedParams} params - The parameters for this event
 * @property {string} formOrigin - vertical that triggered open
 * @property {GUID} badgeId - badge id if editing, null of creating new
 * @return {LogObject<badgesSetupModalLoadedParams>} LogObject<badgesSetupModalLoadedParams>
 */
export function badgesSetupModalLoaded(params) {
    return { evid: 120, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'automateBadgeClick' event (evid: 121)
 *
 * Event description: when user clicks "Automate a badge"
 *
 * @param {automateBadgeClickParams} params - The parameters for this event
 * @property {string} origin - dashboard/editor
 * @return {LogObject<automateBadgeClickParams>} LogObject<automateBadgeClickParams>
 */
export function automateBadgeClick(params) {
    return { evid: 121, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'memberProfileCardBadgesLayoutChange' event (evid: 122)
 *
 * Event description: Member profile card badges layout change.
 *
 * @param {memberProfileCardBadgesLayoutChangeParams} params - The parameters for this event
 * @property {string} size - size
 * @property {string} layoutType - layout_type
 * @return {LogObject<memberProfileCardBadgesLayoutChangeParams>} LogObject<memberProfileCardBadgesLayoutChangeParams>
 */
export function memberProfileCardBadgesLayoutChange(params) {
    return { evid: 122, src: 107, endpoint: 'badges', params: params };
}
/**
 * A function to create a log object for the 'manageBadgesInContactCard' event (evid: 123)
 *
 * Event description: Assigning/removing badges on contact card (in Site Members)
 *
 * @param {manageBadgesInContactCardParams} params - The parameters for this event
 * @property {GUID} assigneeMemberId - assigned member ID
 * @property {string} actionType - assign_initiated/assigned/remove_initiated/removed
 * @property {string} origin - contact_card
 * @property {string} badgeIds - array of badge IDs that were selected
 * @return {LogObject<manageBadgesInContactCardParams>} LogObject<manageBadgesInContactCardParams>
 */
export function manageBadgesInContactCard(params) {
    return { evid: 123, src: 107, endpoint: 'badges', params: params };
}
//# sourceMappingURL=index.js.map